import React, { useState, useEffect } from "react";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  GroupItem,
} from "devextreme-react/form";
import Popup from "devextreme-react/popup";
import LoadIndicator from "devextreme-react/load-indicator";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";
import { Toast } from "devextreme-react/toast";
import GroupCaption from "../../pages/group-caption/GroupCaption";
import CustomerSearchEcgDeviceForm from "../customer-search-ecg-device-form/CustomerSearchEcgDeviceForm";
import CustomerEcgDeviceSearchPatientForm from "../customer-ecg-device-search-patient-form/CustomerEcgDeviceSearchPatientForm";

export default function CustomerPatientAssignEcgDeviceForm({ fetchTrigger }) {
  const { user } = useAuth();

  const [loadingSearchButton, setLoadingSearchButton] = useState(false);
  const [searchDevicePopupVisible, setSearchDevicePopupVisible] =
    useState(false);
  const [searchPatientPopupVisible, setSearchPatientPopupVisible] =
    useState(false);

  const [formData, setFormData] = useState({
    deviceId: "",
    serialNo: "",
    patientName: "",
    patientToken: "",
  });

  const openSearchDevicePopup = () => setSearchDevicePopupVisible(true);

  const openSearchPatientPopup = () => setSearchPatientPopupVisible(true);

  const closeSearchDevicePopup = () => setSearchDevicePopupVisible(false);

  const closeSearchPatientPopup = () => setSearchPatientPopupVisible(false);

  const onSelectEcgDevice = (data) => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        deviceId: data[0].deviceId,
        serialNo: data[0].serialNo,
      }));
    }

    setSearchDevicePopupVisible(false);
  };

  const onSelectPatient = (data) => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        patientName: data[0].name,
        patientToken: data[0].patientToken,
      }));
    }

    setSearchPatientPopupVisible(false);
  };

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "success",
    message: "",
  });

  const groupCaptionNamedRender = (iconName) => {
    const groupCaptionRender = (data) => (
      <GroupCaption iconName={iconName} {...data} />
    );
    return groupCaptionRender;
  };

  const assignToPatient = async () => {
    if (!formData.patientToken || !formData.deviceId) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Invalid input",
      });
    } else {
      try {
        const response = await axios
          .post(
            backendlink + "customer/updatepatientecgdevices",
            {
              deviceId: formData.deviceId,
              organizationToken: user.userToken,
              patientToken: formData.patientToken,
              action: "assign-to-patient",
            },
            {
              headers: {
                token: user.token,
              },
            }
          )
          .then((res) => {
            setLoadingSearchButton(false);

            if (res.data.errorno === 0) {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "success",
                message: "ECG device is assigned to the patient",
              });

              setFormData({
                deviceId: "",
                serialNo: "",
                patientName: "",
                patientToken: "",
              });
            } else {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "error",
                message: res.data.errmessage,
              });
            }
          });
      } catch (error) {
        setLoadingSearchButton(false);
        alert(error);
      }
    }
  };

  useEffect(() => {}, [user, fetchTrigger]);

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  return (
    <div>
      <form>
        <Form formData={formData} style={{ paddingTop: "20px" }}>
          <GroupItem
            iconName="user"
            captionRender={groupCaptionNamedRender("user")}
            caption="Assign Device"
            colCount={20}
          >
            <Item
              colSpan={19}
              dataField={"serialNo"}
              editorOptions={{ readOnly: true }}
            >
              <Label text="Device Id" />
            </Item>
            <ButtonItem>
              <ButtonOptions
                icon="find"
                type={"default"}
                useSubmitBehavior={false}
                onClick={openSearchDevicePopup}
              />
            </ButtonItem>
            <Item
              colSpan={19}
              dataField={"patientName"}
              editorOptions={{ readOnly: true }}
            >
              <Label text="Patient Name" />
            </Item>
            <ButtonItem>
              <ButtonOptions
                icon="find"
                type={"default"}
                useSubmitBehavior={false}
                onClick={openSearchPatientPopup}
              />
            </ButtonItem>
          </GroupItem>

          <ButtonItem colSpan={2} cssClass="full-width-button">
            <ButtonOptions
              width={"100%"}
              type={"default"}
              useSubmitBehavior={false}
              onClick={assignToPatient}
            >
              <span className="dx-button-text">
                {loadingSearchButton ? (
                  <LoadIndicator
                    width={"24px"}
                    height={"24px"}
                    visible={true}
                  />
                ) : (
                  "Assign"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />

      <Popup
        visible={searchDevicePopupVisible}
        showCloseButton={true}
        showTitle={false}
        onHiding={() => setSearchDevicePopupVisible(false)}
        hideOnOutsideClick
        dragEnabled={true}
        width={1000}
        height={800}
      >
        <CustomerSearchEcgDeviceForm
          fetchTrigger={fetchTrigger}
          onSelect={onSelectEcgDevice}
          onClose={closeSearchDevicePopup}
        />
      </Popup>

      <Popup
        visible={searchPatientPopupVisible}
        showCloseButton={true}
        showTitle={false}
        onHiding={() => setSearchPatientPopupVisible(false)}
        hideOnOutsideClick
        dragEnabled={true}
        width={1000}
        height={800}
      >
        <CustomerEcgDeviceSearchPatientForm
          onSelect={onSelectPatient}
          onClose={closeSearchPatientPopup}
        />
      </Popup>
    </div>
  );
}